import React from 'react';
import { motion } from 'framer-motion';

export const AuditCockpitIllustration = () => (
  <div className="relative w-full h-48 bg-slate-900/50 rounded-xl border border-slate-700/50 overflow-hidden flex items-center justify-center">
    <div className="absolute inset-0 opacity-20">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_50%_50%,#f59e0b22,transparent_70%)]" />
    </div>
    <div className="flex gap-3 items-end">
      {[40, 70, 45, 90, 65, 80, 50].map((h, i) => (
        <motion.div
          key={i}
          initial={{ height: 0 }}
          animate={{ height: `${h}%` }}
          transition={{ duration: 1, delay: i * 0.1 }}
          className="w-4 bg-gradient-to-t from-amber-600 to-amber-400 rounded-t-sm"
        />
      ))}
    </div>
    <div className="absolute border-t border-slate-700 w-full top-1/2 opacity-30" />
  </div>
);

export const EvidenceVaultIllustration = () => (
  <div className="relative w-full h-48 bg-slate-900/50 rounded-xl border border-slate-700/50 overflow-hidden group">
    <div className="absolute inset-0 flex flex-wrap gap-4 p-6 justify-center content-center">
      {[1, 2, 3, 4, 5, 6].map((i) => (
        <motion.div
          key={i}
          whileHover={{ y: -5, borderColor: '#f59e0b' }}
          className="w-16 h-20 bg-slate-800 border border-slate-700 rounded-md flex flex-col items-center justify-center gap-2 shadow-lg"
        >
          <div className="w-8 h-1 bg-slate-600 rounded-full" />
          <div className="w-10 h-1 bg-slate-700 rounded-full" />
          <div className="w-6 h-6 rounded-full bg-amber-500/10 border border-amber-500/30 flex items-center justify-center">
            <div className="w-2 h-2 bg-amber-500 rounded-full animate-pulse" />
          </div>
        </motion.div>
      ))}
    </div>
  </div>
);

export const EmptyStateVisual = ({ message }) => (
  <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
    <div className="w-20 h-20 bg-slate-800/50 rounded-full flex items-center justify-center mb-4 border border-slate-700">
      <svg className="w-10 h-10 text-slate-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
      </svg>
    </div>
    <h3 className="text-slate-300 font-medium">{message || "No records found"}</h3>
    <p className="text-slate-500 text-sm mt-1 max-w-xs">Try adjusting your filters or adding a new record to get started.</p>
  </div>
);